























































































import mixins from 'vue-typed-mixins';
import { LongTextOptions, ClienteleOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => ClienteleOptions,
    },
  },
  mounted() {
    // set values to defaults
    this.$emit('input', {
      percentage: this.$languageobj(
        'model.question.options.clientele.percentage.default'
      ),
      period: this.$languageobj(
        'model.question.options.clientele.period.default'
      ),
      totalvisit: this.$languageobj(
        'model.question.options.clientele.totalvisit.default'
      ),
      francophonevisit: this.$languageobj(
        'model.question.options.clientele.francophonevisit.default'
      ),
      totalclients: this.$languageobj(
        'model.question.options.clientele.totalclients.default'
      ),
      francophoneclients: this.$languageobj(
        'model.question.options.clientele.francophoneclients.default'
      ),
      ...this.value,
    });
  },
});
